import React from "react";
import { SmartLinkedEntityDisplay } from "@/components/shared/smart-display/SmartLinkedEntityDisplay";
import type { BaseEntity } from "../../types";
import type { SpecializedCellProps } from "./tableCellSpecializedFields.types";

/**
 * Linked entity_id cell: resolves title via /api/entities/[type]/by-ids using row.entity_type.
 */
export function LinkedEntityIdCell<TData extends BaseEntity>({
  fieldValue,
  item,
  isEditing,
}: SpecializedCellProps<TData>) {
  const rec = item as Record<string, unknown>;
  const entityType = typeof rec.entity_type === "string" ? rec.entity_type : undefined;
  const entityId =
    fieldValue !== null && fieldValue !== undefined && String(fieldValue).trim() !== ""
      ? String(fieldValue)
      : undefined;

  return (
    <div className="min-w-0 max-w-[280px]">
      <SmartLinkedEntityDisplay entityType={entityType} entityId={entityId} disabled={isEditing} />
    </div>
  );
}
